<div class="flex w-full items-center">
    <input matInput #field_name [(ngModel)]="value" [spellcheck]="false" [class.highlight]="highlightState" (input)="onInput($event)" (blur)="blur()" (focus)="focus()" >
    <button class="">
        <fa-icon [icon]="['fal','barcode-read']" (click)="scanBarcode()"></fa-icon>
    </button>
</div>

<div class="frosty" [class.mb-4]="scannerActive">
<zxing-scanner *ngIf="scannerActive" [formats]="allowedFormats" [tryHarder]="true"
    (scanSuccess)="handleBarcodeResult($event)"></zxing-scanner>
</div>
<!-- 
<pre>
    Dirty:{{ngControl.dirty}}
    Touched:{{ngControl.touched}}
    Valid:{{ngControl.valid}}
    Value:{{ngControl.value}}
    Errors:{{ngControl.errors | json}}
</pre> -->